import React, {useEffect, useRef, useState} from "react";
import {blobToBase64} from "../utils";
import axios from "axios";
import {useSelector} from "react-redux";
import useTranslation from "../../virtual_congress/effects/use_translation";

const SendViaEmail = ({
                        tagOwner,
                        storedPhotoId,
                        photoBoothConfig,
                        translationHtmlContent,
                      }) => {
  const t = useTranslation(translationHtmlContent)
  const [email, setEmail] = useState("") // tagOwner?.email
  const [sending, setSending] = useState()
  const [sendingStatus, setSendingStatus] = useState()
  const sendViaEmailUrl = useSelector(state => state.photo_booth.send_via_email_url?.replace("@@photo_booth_config_id@@", photoBoothConfig.id))

  const onSendViaEmail = () => {
    setSending(true)
    const formData = new FormData();

    formData.append("stored_photo_id", storedPhotoId);
    formData.append("tag_owner_id", tagOwner.id);
    formData.append("email", email);

    axios.post(sendViaEmailUrl, formData)
      .then((data) => {
        setSending(false)
        setSendingStatus("success")
      })
      .catch((error) => {
        setSending(false)
        setSendingStatus("error")
      })
  }

  useEffect(() => {
    if (sendingStatus) {
      const sendingTimeout = setTimeout(() => {
        setSendingStatus(undefined)
      }, 4000)

      return () => {
        clearInterval(sendingTimeout)
      }
    }
  }, [sendingStatus, setSendingStatus])


  if (sending) {
    return t("photo_booth.final_image.sending_via_email", {}, "<div class='alert alert-primary'>Sending...</div>")
  }

  if (sendingStatus) {
    if (sendingStatus === "success") {
      return t("photo_booth.final_image.sent_via_email", {}, "<div class='alert alert-success'>Success</div>")
    } else {
      return t("photo_booth.final_image.error_sending_via_email", {}, "<div class='alert alert-danger'>Error</div>")
    }
  }

  if (!photoBoothConfig.enable_send_via_email || !storedPhotoId) {
    return null
  }

  return <div className="send-via-email-container">
    <div className="send-via-email-text">
      {t("photo_booth.final_image.send_via_email_text", {}, "Send via email")}
    </div>
    <div className="send-via-email-form">
      <div className="form-group">
        <label htmlFor="send-via-email-email">{t("photo_booth.final_image.email_input_label", {}, "Email")}</label>
        <input type="email"
               value={email}
               onChange={(e) => setEmail(e.target.value)}
               className="form-control" id="send-via-email-email" aria-describedby="emailHelp" />
      </div>

      {email && <button
        className={"photo-booth-button send-via-email-button"}
        onClick={onSendViaEmail}
        type={"button"}>
        {t("photo_booth.final_image.send_via_email_button", {}, "Send")}
      </button>}
    </div>
  </div>
}

const FinalImage = ({
                      tagOwner,
                      editedPhotoScissorsImageBlob,
                      editedFabricImageBlob,
                      editedPixiImageBlob,
                      editedDokaImageBlob,
                      originalFile,
                      photoBoothConfig,
                      onResetClicked,
                      onBackClicked,
                      translationHtmlContent,
                    }) => {
  const t = useTranslation(translationHtmlContent)
  const imgRef = useRef(null);
  const [dataUrl, setDataUrl] = useState()
  const [sending, setSending] = useState()
  const [storedPhotoId, setStoredPhotoId] = useState()
  const uploadUrl = useSelector(state => state.photo_booth.upload_url?.replace("@@photo_booth_config_id@@", photoBoothConfig.id))

  useEffect(() => {
    blobToBase64(editedFabricImageBlob).then(du => {
      setDataUrl(du)
    })
  }, [])

  const onSave = () => {
    setSending(true)
    const formData = new FormData();

    formData.append("fabric_file", editedFabricImageBlob);
    formData.append("pixi_file", editedPixiImageBlob);
    formData.append("doka_file", editedDokaImageBlob);
    formData.append("tag_owner_id", tagOwner.id);

    axios.patch(uploadUrl, formData)
      .then((data) => {
        setStoredPhotoId(data?.data?.sticker_image_stored_photo_id)
        setSending(false)
      })
      .catch((error) => {
        alert(error)
        setSending(false)
      })
  }

  useEffect(() => {
    onSave()
  }, [])

  return <div className={"final-image-container"}>
    <div className={"image-container"}>
      <img
        src={dataUrl}
        className={"final-image"}
        width={photoBoothConfig.target_image_width}
        height={photoBoothConfig.target_image_height}
      />
      {sending && t("photo_booth.final_image.processing_overlay", {}, <></>)}
    </div>

    <div className="button-container">
      <button
        className={"photo-booth-button back-button"}
        onClick={onResetClicked}
        type={"button"}>
        {t("photo_booth.final_image.reset_button_html", {}, "Reset")}
      </button>
    </div>
    <SendViaEmail photoBoothConfig={photoBoothConfig} translationHtmlContent={translationHtmlContent}
                  storedPhotoId={storedPhotoId} tagOwner={tagOwner}/>
  </div>
}

export default FinalImage